
const svgCache: Record<string, SVGSVGElement> = {};

export const getCachedSVG = async (
    url: string,
): Promise<SVGSVGElement | null> => {

    if (svgCache[url]) {
        return svgCache[url]
    };

  const data = fetch(url)
    .then((res) => res.text())
    .then((rawSvg) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(rawSvg, 'image/svg+xml');
        const svg = doc.querySelector('svg');

        if (svg) {
            svgCache[url] = svg
            return svg
        } else {
            return null
        }
    })
    .catch((e) => {
        console.error(e)
        return null
    });


    return data
};